import React from 'react'

const IgTrimPlate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={343}
    height={176}
    viewBox="0 0 343 176"
    fill="none"
    style={{ zoom: 2, width: '170px' , height:'100px' }}
    {...props}
  >
    <path
      d="M102.846 71.2406C102.846 84.0495 97.9006 87.0711 91.814 90.5889L54.7457 111.992C52.0463 113.551 49.582 113.83 47.6577 113.046C45.9597 111.74 44.9235 109.354 44.9235 106.088V63.8218C44.9235 50.7865 49.8694 47.9826 55.956 44.4735C55.956 44.4735 58.2548 43.2283 58.3071 42.4098C58.3071 42.3488 58.3071 42.2966 58.3158 42.2443L88.8011 24.6462C89.6719 24.1238 91.9271 23.6536 93.033 23.0702C95.7323 21.5115 98.1966 21.2329 100.121 22.0166C101.819 23.3227 102.855 25.7086 102.855 28.9739V71.2406H102.846ZM112.399 7.57935L111.18 6.87403C110.265 6.42124 108.959 6.55185 107.514 7.38778L39.0458 46.9203C36.2855 48.5138 34.0303 49.7329 34.0303 54.8268V124.853C34.0303 126.142 34.5266 127.039 35.3364 127.466L36.5555 128.171C37.4785 128.65 38.802 128.519 40.2649 127.675L108.733 88.1421C111.493 86.5486 113.748 85.3731 113.748 80.2356V10.209C113.748 8.8942 113.235 7.9886 112.399 7.57935Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M102.855 71.2405C102.855 84.0494 97.9092 87.0796 91.8225 90.5888L54.7456 112.001C52.0462 113.559 49.582 113.838 47.6576 113.054C45.9596 111.748 44.9234 109.362 44.9234 106.097V63.8303C44.9234 50.7863 49.8694 47.9912 55.956 44.482C55.956 44.482 58.2547 43.2368 58.307 42.4183C58.307 42.3574 58.307 42.3051 58.3157 42.2529L88.801 24.6461C89.6718 24.1236 91.927 23.6534 93.0329 23.07C95.7323 21.5113 98.1965 21.2327 100.121 22.0164C101.819 23.3225 102.855 25.7084 102.855 28.9738V71.2405ZM112.407 7.56177L111.188 6.85645C110.274 6.40366 108.968 6.53427 107.522 7.3702L39.0371 46.9114C36.2768 48.5049 34.0215 49.724 34.0215 54.8179V124.853C34.0215 126.142 34.5178 127.039 35.3276 127.465L36.5467 128.171C37.4697 128.65 38.7933 128.519 40.2561 127.674L108.741 88.1332C111.502 86.5397 113.757 85.3642 113.757 80.2267V10.1915C113.757 8.87662 113.243 7.97103 112.407 7.56177Z"
      fill="white"
    />
    <path
      d="M100.052 21.9824C102.507 22.949 104.066 25.6483 104.066 29.6712V71.938C104.066 84.7468 99.1198 87.7771 93.0332 91.2863L55.9563 112.69C52.63 114.605 49.6432 114.597 47.623 113.02"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M56.1134 42.4627C55.4952 42.8197 54.9901 42.5149 54.9901 41.7922C54.9901 41.0694 55.4952 40.1813 56.1134 39.8243L92.8334 18.6212C93.4516 18.2642 93.9567 18.569 93.9567 19.2917C93.9567 20.0145 93.4516 20.9026 92.8334 21.2596M36.5561 128.172C35.7463 127.745 35.25 126.848 35.25 125.559V55.5241C35.25 50.4301 37.5053 49.2023 40.2656 47.6176L108.742 8.08504C110.188 7.24911 111.494 7.1185 112.408 7.5713"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M112.399 7.57122L111.18 6.8659C110.265 6.4131 108.959 6.55243 107.514 7.37966L39.0458 46.9122C36.2855 48.5057 34.0303 49.7247 34.0303 54.8187V124.845C34.0303 126.143 34.5266 127.031 35.3364 127.458L36.5555 128.163C37.4785 128.642 38.7933 128.52 40.2649 127.666L108.742 88.134C111.502 86.5405 113.757 85.3649 113.757 80.2275V10.2009C113.757 8.88606 113.243 7.98048 112.407 7.57122H112.399Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M91.9706 93.8108L57.0357 113.978C49.4862 118.331 43.3125 115.728 43.3125 108.178V63.5867C43.3125 49.907 49.4862 46.3021 57.0357 41.9483L91.9706 21.7815C99.5201 17.4277 105.694 20.0313 105.694 27.5808V72.1724C105.694 85.8956 99.5201 89.457 91.9706 93.8108Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M92.8247 93.3488C93.443 92.9918 93.948 93.2966 93.948 94.0193C93.948 94.7421 93.443 95.6302 92.8247 95.9873L56.1048 117.182C55.4865 117.539 54.9814 117.243 54.9814 116.511C54.9814 115.78 55.4865 114.9 56.1048 114.543"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M58.3164 42.4009C58.3687 41.5824 58.447 41.1383 59.1785 40.6855"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M54.7451 111.993L91.822 90.5894C97.9086 87.0802 102.855 84.05 102.855 71.2411V28.9744C102.855 25.709 101.818 23.3231 100.12 22.017C98.2047 21.2333 95.7317 21.512 93.0324 23.0706C91.9265 23.654 89.6712 24.1329 88.8005 24.6467L58.3152 42.2448C58.3152 42.297 58.3064 42.3493 58.3064 42.4102C58.2542 43.2287 55.9554 44.4739 55.9554 44.4739C49.8688 47.9831 44.9229 50.7869 44.9229 63.8222V106.089C44.9229 109.354 45.9591 111.74 47.6571 113.046C49.5727 113.83 52.0457 113.551 54.7451 111.993Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M181.283 107.482L182.589 108.23L184.008 107.412V105.906L187.178 104.077M185.872 104.826L187.178 105.575L188.597 104.756V103.25L191.767 101.421M190.461 102.179L191.767 102.928L193.186 102.109V100.603L196.356 98.774M162.936 118.079L164.242 118.828L165.662 118.009V116.503L168.831 114.674M167.525 115.423L168.831 116.172L170.25 115.353V113.847L173.42 112.018M172.114 112.776L173.411 113.525L174.831 112.706V111.2L178 109.371M176.703 110.129L178.009 110.878L179.428 110.059V108.553L182.598 106.724M194.997 99.549L196.295 100.298C204.776 95.23 211.516 89.126 211.516 75.0632V19.9615C211.516 15.6251 210.088 12.7516 207.719 11.3323L201.415 7.73603C198.393 5.92485 193.831 6.48214 188.763 9.40789L146.87 33.5976C137.823 38.8222 130.422 43.8378 130.422 59.555V114.657C130.422 119.611 131.798 122.555 134.096 123.887L140.383 127.474C143.17 129.103 147.236 128.406 151.895 125.95V124.444L155.064 122.615M153.758 123.373L155.056 124.122L156.475 123.303V121.797L159.645 119.968M158.347 120.726L159.645 121.475L161.064 120.656V119.15L164.233 117.321"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M158.339 120.735L159.645 121.484L161.064 120.665V119.159L164.234 117.33"
      fill="white"
    />
    <path
      d="M153.75 123.382L155.056 124.14L156.475 123.321V121.815L159.645 119.986"
      fill="white"
    />
    <path
      d="M195.007 99.5577L196.313 100.307C204.794 95.2388 211.543 89.126 211.543 75.0719V19.9615C211.543 15.6251 210.115 12.7516 207.746 11.3323L201.442 7.73603C198.42 5.92485 193.858 6.48214 188.781 9.40789L146.871 33.6063C137.815 38.8309 130.414 43.8552 130.414 59.5637V114.674C130.414 119.629 131.79 122.572 134.089 123.904L140.376 127.492C143.162 129.12 147.228 128.423 151.896 125.968V124.461L155.065 122.633"
      fill="white"
    />
    <path
      d="M176.703 110.137L178.001 110.886L179.429 110.067V108.561L182.589 106.732"
      fill="white"
    />
    <path
      d="M172.114 112.784L173.412 113.541L174.84 112.714V111.208L178.001 109.379"
      fill="white"
    />
    <path
      d="M167.525 115.44L168.823 116.189L170.242 115.37V113.864L173.412 112.035"
      fill="white"
    />
    <path
      d="M162.928 118.088L164.234 118.837L165.653 118.019V116.512L168.823 114.684"
      fill="white"
    />
    <path
      d="M190.47 102.188L191.776 102.937L193.195 102.118V100.612L196.365 98.7832"
      fill="white"
    />
    <path
      d="M185.881 104.834L187.187 105.592L188.606 104.765V103.258L191.776 101.43"
      fill="white"
    />
    <path
      d="M181.291 107.491L182.588 108.239L184.016 107.421V105.915L187.186 104.086"
      fill="white"
    />
    <path
      d="M136.5 125.227C134.115 123.938 132.678 120.977 132.678 115.91V60.7992C132.678 45.082 140.079 40.0664 149.135 34.8419L191.036 10.6434C196.156 7.68284 200.754 7.14296 203.775 9.0151"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M195.294 41.5663V67.0274M138.842 126.596C136.456 125.307 135.02 122.347 135.02 117.279V62.1772C135.02 46.46 142.43 41.4444 151.477 36.2199L193.378 12.0301C198.498 9.06955 203.096 8.52968 206.117 10.4018M207.737 11.3335C204.715 9.52234 200.152 10.0796 195.076 13.0054L153.175 37.1951C144.119 42.4197 136.718 47.4352 136.718 63.1525V118.263C136.718 123.209 138.093 126.152 140.375 127.484M155.056 122.634V124.141M159.645 119.978V121.485M164.234 117.331V118.838M168.857 114.78V116.286M173.411 112.028V113.535M178 109.381V110.888M182.589 106.734V108.24M187.178 104.087V105.593M191.776 101.431V102.938M196.312 98.8014V100.308M151.111 58.729C150.728 58.5287 150.493 58.0672 150.493 57.4055C150.493 56.1341 151.364 54.6016 152.443 53.9747C152.948 53.6873 153.41 53.6438 153.758 53.8092"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M163.894 79.4167L174.726 73.1646C175.91 72.4767 176.877 70.7875 176.877 69.3943V56.8379"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M170.39 43.4707C168.335 44.655 166.663 43.9496 166.663 41.8947V35.5816C166.663 31.7851 168.344 30.8795 170.39 29.6953L177.861 25.385C179.916 24.2008 181.588 24.9061 181.588 26.9611M173.856 42.5216C173.385 42.5826 173.081 42.2865 173.081 41.2764V37.4538C173.081 35.7558 173.917 35.1027 174.944 34.5106L180.787 31.1321C181.544 30.6967 182.206 30.3919 182.494 30.9666"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M182.493 30.9766C182.598 31.1768 182.65 31.4816 182.65 31.9257V35.7483C182.65 37.4724 181.814 38.0994 180.787 38.6915L174.944 42.0613C174.543 42.2964 174.16 42.4793 173.855 42.5229"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M150.032 58.1001C149.658 57.8998 149.432 57.4383 149.432 56.7853C149.432 55.514 150.302 53.9814 151.382 53.3632C151.887 53.0758 152.349 53.0323 152.697 53.1977"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M194.963 35.2615C195.128 35.279 195.311 35.2354 195.511 35.1222C196.112 34.7739 196.591 33.9293 196.591 33.224C196.591 32.9889 196.539 32.7973 196.443 32.658M194.945 35.4444C194.945 36.5154 195.685 36.9595 196.6 36.4371C197.514 35.9146 198.245 34.6172 198.245 33.5374C198.245 32.4577 197.505 32.0223 196.6 32.5448C195.685 33.0672 194.945 34.3647 194.945 35.4444Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M205.508 29.3483C205.508 30.0972 204.994 31.0028 204.358 31.3685C203.723 31.7342 203.209 31.4294 203.209 30.6806C203.209 29.9317 203.723 29.0261 204.358 28.6604C204.994 28.2947 205.508 28.5995 205.508 29.3483Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M201.18 50.5951L201.781 50.2468C203.235 49.4022 204.428 50.1162 204.428 51.8316C204.428 53.547 203.243 55.6281 201.781 56.4727L201.188 56.8123M205.986 35.4613C205.864 35.5309 205.769 35.47 205.769 35.3307V29.2005C205.769 28.2775 205.133 27.8944 204.349 28.3472C203.566 28.8 202.93 29.9145 202.93 30.8375V36.9677C202.93 37.107 202.834 37.2725 202.712 37.3421C202.59 37.4118 202.494 37.3508 202.494 37.2115V31.0814C202.494 29.8797 203.322 28.4255 204.34 27.8421C205.359 27.25 206.187 27.7551 206.187 28.948V35.0782C206.187 35.2175 206.091 35.3829 205.969 35.4526L205.986 35.4613ZM205.29 30.0016C205.29 29.6881 205.072 29.5575 204.802 29.7143C204.532 29.871 204.314 30.2454 204.314 30.5676C204.314 30.8898 204.532 31.0117 204.802 30.855C205.072 30.6982 205.29 30.3151 205.29 30.0016Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M156.457 67.3218C156.457 64.2132 154.35 62.907 151.755 64.4047C149.16 65.9024 147.053 69.6467 147.053 72.7553M147.044 72.7466V80.7489M147.044 89.1866V98.286C147.044 100.594 148.629 101.56 150.588 100.454C150.588 100.454 150.614 100.437 150.631 100.428L156.518 97.0321M191.488 76.8392L197.618 73.3039C199.594 72.1632 201.205 69.3419 201.205 67.017V56.7769M201.197 50.5858V41.4863"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M201.919 56.4102V66.6068C201.919 69.3932 199.986 72.7804 197.618 74.1475L191.697 77.5609M156.527 97.8758L150.632 101.28C148.263 102.648 146.33 101.489 146.33 98.703V89.4207"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M197.253 67.0611L147.228 95.9442M201.197 41.4869C201.197 38.3783 199.09 37.0721 196.495 38.5698C193.9 40.0675 191.793 43.8118 191.793 46.9204L156.458 67.3223"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M157.163 66.5473L171.113 58.5015M177.086 55.0533L191.088 46.9727"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M197.618 73.3736L197.418 66.9648M150.632 100.437L147.228 95.9525"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path d="M188.606 16.7388V18.2365L191.767 16.4166V14.9102" fill="white" />
    <path
      d="M188.606 16.7388V18.2365L191.767 16.4166V14.9102"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M150.858 37.4728L151.886 37.943V39.4407L155.047 37.6121V36.1144L154.08 35.6094L150.858 37.4728Z"
      fill="white"
    />
    <path
      d="M150.858 37.4728L151.886 37.943V39.4407L155.047 37.6121V36.1144L154.08 35.6094L150.858 37.4728Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M156.475 35.2946V36.7923L159.636 34.9637V33.466L158.66 32.9609L155.438 34.8244L156.475 35.2946Z"
      fill="white"
    />
    <path
      d="M156.475 35.2946V36.7923L159.636 34.9637V33.466L158.66 32.9609L155.438 34.8244L156.475 35.2946Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M160.02 32.1779L161.056 32.6481L161.073 34.1371L164.225 32.3172V30.8108L163.241 30.3145L160.02 32.1779Z"
      fill="white"
    />
    <path
      d="M160.02 32.1779L161.056 32.6481L161.073 34.1371L164.225 32.3172V30.8108L163.241 30.3145L160.02 32.1779Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M164.608 29.5314L165.636 30.0016L165.662 31.4906L168.823 29.662V28.1643L167.83 27.668L164.608 29.5314Z"
      fill="white"
    />
    <path
      d="M164.608 29.5314L165.636 30.0016L165.662 31.4906L168.823 29.662V28.1643L167.83 27.668L164.608 29.5314Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M169.188 26.884L170.225 27.3542L170.251 28.8432L173.412 27.0146V25.5169L172.41 25.0293L169.188 26.884Z"
      fill="white"
    />
    <path
      d="M169.188 26.884L170.225 27.3542L170.251 28.8432L173.412 27.0146V25.5169L172.41 25.0293L169.188 26.884Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M173.769 24.2375L174.805 24.7077L174.84 24.7164V26.188L178 24.3681V22.8617L176.99 22.3828L173.769 24.2375Z"
      fill="white"
    />
    <path
      d="M173.769 24.2375L174.805 24.7077L174.84 24.7164V26.188L178 24.3681V22.8617L176.99 22.3828L173.769 24.2375Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M179.428 22.0854V23.5396L182.589 21.711V20.2133L181.579 19.7344L178.357 21.5891L179.385 22.0593"
      fill="white"
    />
    <path
      d="M179.428 22.0854V23.5396L182.589 21.711V20.2133L181.579 19.7344L178.357 21.5891L179.385 22.0593"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M182.938 18.9426L183.974 19.4128L184.017 19.4389V20.8931L187.178 19.0645V17.5668L186.159 17.0879L182.938 18.9426Z"
      fill="white"
    />
    <path
      d="M182.938 18.9426L183.974 19.4128L184.017 19.4389V20.8931L187.178 19.0645V17.5668L186.159 17.0879L182.938 18.9426Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M191.776 14.9116L190.739 14.4414L187.518 16.2961L188.554 16.7663"
      fill="white"
    />
    <path
      d="M191.776 14.9116L190.739 14.4414L187.518 16.2961L188.554 16.7663"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M195.328 11.793L192.106 13.6564L193.134 14.1266L193.195 14.1527V15.5895L196.356 13.7696V12.2632L195.328 11.793Z"
      fill="white"
    />
    <path
      d="M195.328 11.793L192.106 13.6564L193.134 14.1266L193.195 14.1527V15.5895L196.356 13.7696V12.2632L195.328 11.793Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M152.687 53.207L153.758 53.8253C154.15 54.0168 154.394 54.4783 154.394 55.1575C154.394 56.4288 153.523 57.9527 152.443 58.5796C151.93 58.8757 151.459 58.9105 151.111 58.7277L150.031 58.1094"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M153.759 123.382L155.056 124.131L156.476 123.312V121.806L159.636 119.977M158.339 120.735L159.636 121.484L161.056 120.665V119.159L164.217 117.33"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M195.32 11.793V13.2994L193.231 14.501M190.731 14.4401V15.9465L188.642 17.1482M186.143 17.0872V18.5936L183.992 19.8301M181.554 19.7343V21.2407L179.438 22.4685M176.965 22.3901V23.8965L174.84 25.1243M172.376 25.0372V26.5437L170.242 27.7714M167.787 27.6843V29.1908L165.68 30.4011M163.198 30.3402V31.8466L161.065 33.0831M158.609 32.9873V34.4937L156.502 35.7128M154.02 35.6344V37.1408L151.791 38.4295"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M196.364 13.7623L195.328 13.3008"
      stroke="#B8A3CE"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M195.294 67.0176H201.198"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M193.631 41.5742H201.076"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M195.294 67.0177L194.223 66.4082"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M194.214 41.6172V66.4077L147.341 93.471"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M181.293 107.482L182.599 108.23L184.018 107.412V105.906L187.188 104.077M185.882 104.835L187.188 105.583L188.607 104.765V103.258L191.777 101.43M190.47 102.179L191.768 102.928L193.187 102.109V100.603L196.357 98.774M162.937 118.079L164.243 118.828L165.662 118.009V116.503L168.832 114.674M167.526 115.432L168.832 116.181L170.251 115.362V113.856L173.421 112.027M172.115 112.785L173.421 113.533L174.84 112.715V111.208L178.01 109.38M176.704 110.129L178.01 110.878L179.429 110.059V108.553L182.599 106.724M195.007 99.549L196.313 100.298C204.794 95.23 211.534 89.126 211.534 75.0632V19.9615C211.534 15.6251 210.106 12.7516 207.738 11.3323L201.433 7.73603C198.412 5.92485 193.849 6.48214 188.772 9.40789L146.871 33.5976C137.824 38.8222 130.414 43.8378 130.414 59.555V114.657C130.414 119.611 131.79 122.555 134.089 123.887L140.376 127.474C143.162 129.103 147.228 128.406 151.896 125.95V124.444L155.065 122.615"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M159.531 119.656L162.657 118.968C163.188 118.898 163.781 118.698 164.399 118.332L188.014 104.696C190.356 103.346 192.272 102.127 192.272 97.9737V81.4815C192.272 81.3073 192.263 81.1419 192.237 80.9851L191.662 77.3279C190.922 74.4631 188.049 73.7143 185.48 75.1946L157.302 91.4604C154.733 92.9407 156.527 94.4035 156.527 96.9636"
      fill="white"
    />
    <path
      d="M150.032 111.721C149.658 111.521 149.432 111.059 149.432 110.406C149.432 109.135 150.302 107.603 151.382 106.984C151.887 106.697 152.349 106.653 152.697 106.819M151.112 112.339C150.729 112.139 150.494 111.686 150.494 111.016C150.494 109.745 151.365 108.221 152.444 107.594C152.95 107.306 153.411 107.263 153.759 107.428"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M152.687 106.828L153.758 107.446C154.15 107.638 154.394 108.099 154.394 108.779C154.394 110.05 153.523 111.574 152.443 112.201C151.93 112.497 151.459 112.532 151.111 112.349L150.031 111.731"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M195.258 85.6079C194.884 85.4077 194.657 84.9461 194.657 84.2931C194.657 83.0218 195.528 81.4979 196.608 80.871C197.113 80.5836 197.574 80.5401 197.923 80.7055M196.338 86.2262C195.955 86.0259 195.72 85.5644 195.72 84.9026C195.72 83.6313 196.59 82.1075 197.67 81.4805C198.175 81.1932 198.637 81.1496 198.985 81.3151"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M147.044 89.1873C145.66 89.8927 144.554 89.1699 144.554 87.5155V85.295C144.554 83.6406 145.651 81.6553 147.035 80.7584M197.905 80.7148L198.976 81.3331C199.368 81.5246 199.621 81.9861 199.621 82.6653C199.621 83.9366 198.741 85.4692 197.67 86.0874C197.156 86.3835 196.686 86.4183 196.338 86.2355L195.258 85.6085"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M147.044 80.7578V89.1955"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M201.198 56.8129L199.317 56.7955C197.863 56.7781 196.67 55.3762 196.67 53.6608C196.67 51.9454 197.854 50.5609 199.317 50.5783L201.198 50.5957"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.773 54.4612C196.834 54.435 196.895 54.4089 196.956 54.3741L198.837 53.2856C199.586 52.8503 200.187 51.7879 200.187 50.9084C200.187 50.804 200.187 50.7082 200.161 50.6211"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M146.33 81.3069V73.1653C146.33 69.5865 148.76 65.2849 151.755 63.5608C154.646 61.889 157.014 63.2299 157.171 66.5563M201.467 50.543C201.31 52.18 200.195 54.026 198.837 54.8097L197.235 55.7327"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M191.088 46.9817C191.236 43.4812 193.604 39.3974 196.495 37.7255C199.491 36.0014 201.911 37.4991 201.911 41.0692V50.1774"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M177.068 49.873L179.21 51.1095C179.463 51.2402 179.628 51.5449 179.628 51.9803V54.9322C179.628 55.7681 179.054 56.7782 178.34 57.1874L174.195 59.582C173.873 59.7736 173.577 59.7997 173.35 59.6952L171.112 58.3978"
      fill="white"
    />
    <path
      d="M177.068 49.873L179.21 51.1095C179.463 51.2402 179.628 51.5449 179.628 51.9803V54.9322C179.628 55.7681 179.054 56.7782 178.34 57.1874L174.195 59.582C173.873 59.7736 173.577 59.7997 173.35 59.6952L171.112 58.3978"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M176.772 52.9883V54.1638C176.772 54.5034 176.494 54.9475 176.154 55.1478L173.629 56.6019"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M171.095 58.4142C170.886 58.2661 170.756 57.9788 170.756 57.5869V54.6351C170.756 53.7991 171.331 52.7804 172.045 52.3711L176.198 49.9765C176.529 49.7849 176.834 49.7588 177.06 49.872"
      fill="white"
    />
    <path
      d="M171.095 58.4142C170.886 58.2661 170.756 57.9788 170.756 57.5869V54.6351C170.756 53.7991 171.331 52.7804 172.045 52.3711L176.198 49.9765C176.529 49.7849 176.834 49.7588 177.06 49.872"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M176.033 53.3978C176.233 53.3804 176.372 53.5371 176.372 53.8071C176.372 54.1728 176.12 54.6082 175.815 54.7823C175.51 54.9565 175.258 54.8084 175.258 54.4514C175.258 54.2163 175.362 53.9551 175.519 53.7461M174.396 54.3731C174.57 54.3818 174.683 54.5298 174.683 54.7823C174.683 55.1393 174.43 55.5834 174.126 55.7576C173.934 55.8708 173.76 55.8533 173.664 55.7314"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M173.342 59.7027C173.072 59.5808 172.897 59.2674 172.897 58.8146V55.8714C172.897 55.0355 173.472 54.0254 174.186 53.6074L178.331 51.2128C178.671 51.0213 178.975 50.9951 179.202 51.1083M178.287 56.3851L174.238 58.7275C173.899 58.9278 173.62 58.8059 173.62 58.4663V55.4099C173.62 55.0703 173.899 54.6262 174.238 54.4346L178.287 52.0923C178.627 51.892 178.906 52.0139 178.906 52.3535V55.4099C178.906 55.7495 178.627 56.1936 178.287 56.3938V56.3851Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M195.258 31.9868C194.884 31.7866 194.657 31.3251 194.657 30.672C194.657 29.4007 195.528 27.8681 196.608 27.2499C197.113 26.9625 197.574 26.919 197.923 27.0845"
      fill="white"
    />
    <path
      d="M195.258 31.9868C194.884 31.7866 194.657 31.3251 194.657 30.672C194.657 29.4007 195.528 27.8681 196.608 27.2499C197.113 26.9625 197.574 26.919 197.923 27.0845"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M197.915 27.0938L198.986 27.712C199.378 27.9035 199.621 28.3651 199.621 29.0442C199.621 30.3156 198.751 31.8394 197.671 32.4663C197.157 32.7624 196.687 32.7972 196.339 32.6144L195.259 31.9961"
      fill="white"
    />
    <path
      d="M197.915 27.0938L198.986 27.712C199.378 27.9035 199.621 28.3651 199.621 29.0442C199.621 30.3156 198.751 31.8394 197.671 32.4663C197.157 32.7624 196.687 32.7972 196.339 32.6144L195.259 31.9961"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M196.339 32.6127C195.956 32.4125 195.721 31.9597 195.721 31.2892C195.721 30.0179 196.591 28.494 197.671 27.8671C198.176 27.5797 198.638 27.5362 198.986 27.7016"
      fill="white"
    />
    <path
      d="M196.339 32.6127C195.956 32.4125 195.721 31.9597 195.721 31.2892C195.721 30.0179 196.591 28.494 197.671 27.8671C198.176 27.5797 198.638 27.5362 198.986 27.7016"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M159.523 119.655C157.781 119.986 156.536 119.011 156.536 117.034V96.998"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M192.237 81.011C191.984 79.0518 190.182 78.451 188.014 79.7049L164.407 93.3322C162.065 94.6819 160.149 96.0664 160.149 100.055V116.538C160.149 118.262 161.186 119.15 162.666 118.967M191.688 77.5801L192.228 81.0196C192.254 81.1763 192.263 81.3418 192.263 81.5159V97.9994C192.263 100.074 191.783 101.416 191.01 102.407"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M191.697 77.571L191.662 77.3533C190.922 74.4973 188.049 73.7397 185.48 75.22L157.311 91.4771C154.742 92.9574 156.536 94.4202 156.536 96.9803"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M159.531 119.656L162.657 118.968C163.188 118.898 163.781 118.698 164.399 118.341L188.005 104.714C188.697 104.315 189.352 103.928 189.931 103.473"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M172.855 111.565C171.801 112.009 170.982 111.417 170.982 110.137V106.854C170.982 104.573 171.949 103.772 173.133 103.084L179.281 99.54C180.378 98.9043 181.292 99.3571 181.414 100.541"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M174.691 110.72C174.178 111.016 173.76 110.842 173.76 110.328V106.88C173.76 106.366 174.178 105.705 174.691 105.409L180.682 101.943C181.196 101.647 181.614 101.821 181.614 102.335"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M170.389 43.4803C171.39 43.0014 172.217 42.6009 173.854 42.5225M181.587 26.9707C181.587 28.1724 181.979 30.1054 182.492 30.9762M181.404 100.524L181.613 102.326V105.775C181.613 106.288 181.195 106.95 180.681 107.246L174.682 110.712L172.844 111.556"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M186.464 11.69C186.76 11.8642 187.231 11.8642 187.518 11.69C187.805 11.5246 187.805 11.2459 187.509 11.0805C187.213 10.9151 186.743 10.9063 186.456 11.0805C186.168 11.2459 186.168 11.5159 186.464 11.69ZM184.514 12.2038C184.801 12.0383 185.28 12.0383 185.568 12.2038C185.864 12.3779 185.864 12.6479 185.576 12.8133C185.289 12.9787 184.81 12.9787 184.523 12.8133C184.227 12.6391 184.227 12.3692 184.514 12.2038ZM182.572 13.3183C182.859 13.1529 183.338 13.1529 183.626 13.3183C183.922 13.4838 183.922 13.7624 183.634 13.9279C183.347 14.0933 182.868 14.0933 182.581 13.9279C182.285 13.7624 182.285 13.4838 182.572 13.3183ZM180.63 14.4416C180.918 14.2762 181.397 14.2762 181.684 14.4416C181.98 14.6071 181.98 14.8857 181.693 15.0512C181.405 15.2166 180.926 15.2166 180.639 15.0512C180.343 14.8857 180.343 14.6071 180.63 14.4416ZM178.689 15.5649C178.976 15.3995 179.455 15.3995 179.742 15.5649C180.038 15.7391 180.038 16.009 179.751 16.1744C179.463 16.3399 178.985 16.3399 178.689 16.1744C178.392 16.0003 178.392 15.7304 178.68 15.5649H178.689ZM176.747 16.6882C177.034 16.5227 177.513 16.5227 177.8 16.6882C178.096 16.8623 178.096 17.1323 177.809 17.2977C177.522 17.4632 177.043 17.4632 176.755 17.2977C176.459 17.1236 176.459 16.8536 176.747 16.6882ZM174.814 17.8028C175.101 17.6373 175.58 17.6373 175.867 17.8028C176.163 17.9769 176.163 18.2469 175.876 18.4123C175.589 18.5777 175.11 18.5777 174.822 18.4123C174.526 18.2469 174.526 17.9682 174.814 17.8028ZM172.872 18.926C173.159 18.7606 173.638 18.7606 173.925 18.926C174.222 19.0915 174.222 19.3701 173.934 19.5356C173.647 19.701 173.168 19.701 172.881 19.5356C172.585 19.3701 172.585 19.0915 172.872 18.926ZM170.93 20.0493C171.217 19.8839 171.696 19.8839 171.984 20.0493C172.28 20.2148 172.28 20.4934 171.992 20.6589C171.705 20.8243 171.226 20.8243 170.939 20.6589C170.643 20.4934 170.643 20.2148 170.93 20.0493ZM168.988 21.1639C169.276 20.9984 169.755 20.9984 170.042 21.1639C170.338 21.338 170.338 21.608 170.051 21.7734C169.763 21.9389 169.284 21.9389 168.997 21.7734C168.701 21.5993 168.701 21.3293 168.988 21.1639ZM167.046 22.2872C167.334 22.1217 167.813 22.1217 168.1 22.2872C168.396 22.4613 168.396 22.7313 168.109 22.8967C167.821 23.0622 167.343 23.0622 167.055 22.8967C166.759 22.7313 166.759 22.4526 167.046 22.2872ZM165.105 23.4105C165.392 23.245 165.871 23.245 166.158 23.4105C166.454 23.5846 166.454 23.8546 166.167 24.02C165.88 24.1854 165.401 24.1854 165.113 24.02C164.817 23.8546 164.817 23.5759 165.105 23.4105ZM163.163 24.5337C163.45 24.3683 163.929 24.3683 164.216 24.5337C164.513 24.6992 164.513 24.9778 164.225 25.1433C163.938 25.3087 163.459 25.3087 163.172 25.1433C162.876 24.9778 162.876 24.6992 163.163 24.5337ZM161.221 25.6483C161.508 25.4829 161.987 25.4829 162.275 25.6483C162.571 25.8138 162.571 26.0924 162.283 26.2578C161.996 26.4233 161.517 26.4233 161.23 26.2578C160.934 26.0837 160.934 25.8138 161.221 25.6483ZM159.279 26.7716C159.567 26.6061 160.046 26.6061 160.333 26.7716C160.629 26.9457 160.629 27.2157 160.342 27.3811C160.054 27.5466 159.575 27.5466 159.288 27.3811C158.992 27.207 158.992 26.937 159.279 26.7716ZM157.337 27.8949C157.625 27.7294 158.104 27.7294 158.391 27.8949C158.687 28.0603 158.687 28.339 158.4 28.5044C158.112 28.6699 157.634 28.6699 157.346 28.5044C157.05 28.339 157.05 28.0603 157.337 27.8949ZM155.396 29.0182C155.683 28.8527 156.162 28.8527 156.449 29.0182C156.745 29.1923 156.745 29.4622 156.458 29.6277C156.171 29.7931 155.692 29.7931 155.404 29.6277C155.108 29.4622 155.108 29.1836 155.396 29.0182ZM153.454 30.1327C153.741 29.9673 154.22 29.9673 154.507 30.1327C154.804 30.2982 154.804 30.5768 154.516 30.7423C154.229 30.9077 153.75 30.9077 153.454 30.7423C153.158 30.5768 153.158 30.2982 153.445 30.1327H153.454ZM151.512 31.256C151.799 31.0906 152.278 31.0906 152.574 31.256C152.87 31.4302 152.871 31.7001 152.583 31.8655C152.296 32.031 151.817 32.031 151.53 31.8655C151.233 31.6914 151.233 31.4215 151.521 31.256H151.512ZM149.57 32.3793C149.858 32.2138 150.337 32.2138 150.624 32.3793C150.92 32.5534 150.92 32.8234 150.633 32.9888C150.345 33.1543 149.866 33.1543 149.579 32.9888C149.283 32.8147 149.283 32.5447 149.57 32.3793ZM148.682 33.5026C148.978 33.668 148.978 33.9467 148.691 34.1121C148.403 34.2776 147.925 34.2776 147.637 34.1121C147.341 33.9467 147.341 33.668 147.629 33.5026C147.916 33.3371 148.395 33.3371 148.682 33.5026Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M152.191 86.9672V90.4328L154.699 91.5212L161.099 87.8292V83.7715"
      fill="white"
    />
    <path
      d="M152.191 86.9672V90.4328L154.699 91.5212L161.099 87.8292V83.7715"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M153.89 87.2969L151.495 89.1168V92.5214L152.305 92.9829L154.691 91.1631V87.7671L153.89 87.2969Z"
      fill="white"
    />
    <path
      d="M153.89 87.2969L151.495 89.1168V92.5214L152.305 92.9829L154.691 91.1631V87.7671L153.89 87.2969Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M152.304 92.9911V89.5864L154.698 87.7578"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M154.751 87.4287L161.099 83.7715"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M152.104 82.9437V86.4007L154.62 87.4891L161.02 83.7971V79.748"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M153.811 83.2734L151.416 85.0933V88.4893L152.226 88.9595L154.612 87.1396V83.7349L153.811 83.2734Z"
      fill="white"
    />
    <path
      d="M153.811 83.2734L151.416 85.0933V88.4893L152.226 88.9595L154.612 87.1396V83.7349L153.811 83.2734Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M152.226 88.9677V85.5543L154.611 83.7344"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M154.673 83.4052L161.021 79.748"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M152.104 78.8851V82.3421L154.62 83.4305L161.02 79.7385V75.6895"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M153.811 79.2168L151.416 81.028V84.4326L152.226 84.9029L154.612 83.083V79.6783L153.811 79.2168Z"
      fill="white"
    />
    <path
      d="M153.811 79.2168L151.416 81.028V84.4326L152.226 84.9029L154.612 83.083V79.6783L153.811 79.2168Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M152.226 84.911V81.4976L154.611 79.6777"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M154.673 79.3466L161.021 75.6895"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M152.104 74.8285V78.2854L154.62 79.3739L161.02 75.6818V71.6328"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M153.811 75.1484L151.416 76.9683V80.373L152.226 80.8432L154.612 79.0233V75.6187L153.811 75.1484Z"
      fill="white"
    />
    <path
      d="M153.811 75.1484L151.416 76.9683V80.373L152.226 80.8432L154.612 79.0233V75.6187L153.811 75.1484Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M152.226 80.8457V77.441L154.611 75.6211"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M154.673 75.2889L161.021 71.623"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M152.104 70.7699V74.2268L154.62 75.3153L161.02 71.6233V67.5742"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M153.811 71.0938L151.416 72.9136V76.3183L152.226 76.7798L154.612 74.9686V71.564L153.811 71.0938Z"
      fill="white"
    />
    <path
      d="M153.811 71.0938L151.416 72.9136V76.3183L152.226 76.7798L154.612 74.9686V71.564L153.811 71.0938Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M152.226 76.788V73.3833L154.611 71.5547"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M154.673 71.2323L161.021 67.5664"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M152.104 67.444V70.1695L154.62 71.2579L161.02 67.5659V64.7969"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M153.34 67.3906L151.416 68.8535V72.2582L152.226 72.7197L154.612 70.8998V67.4951L154.507 67.4429"
      fill="white"
    />
    <path
      d="M153.34 67.3906L151.416 68.8535V72.2582L152.226 72.7197L154.612 70.8998V67.4951L154.507 67.4429"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M152.226 72.7294V69.3247L154.611 67.4961"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M182.188 52.5102V52.7975L184.705 53.886L191.096 50.194V47.3379"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M184.705 51.0996V53.8948"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M191.863 45.4045L193.648 44.6992L194.266 45.0562V48.4609L191.114 49.8367"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M194.275 45.0566L191.906 46.0058"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M180.613 53.5293C180.674 53.7557 180.7 54.0082 180.7 54.2869V70.3872C180.7 74.1402 179.01 75.1067 176.955 76.2997L166.123 82.5604C164.059 83.7534 162.379 83.0394 162.379 80.9757V64.8666C162.379 64.5618 162.414 64.2483 162.483 63.9262"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M163.877 63.2377C163.746 63.6383 163.668 64.0475 163.668 64.4394V79.9128C163.668 81.3147 164.634 81.8894 165.827 81.2102L177.243 74.6186C178.436 73.9307 179.403 72.2327 179.403 70.8308V56.0801"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M188.598 69.4023L191.105 70.4821"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M190.809 66.2248L193.647 64.9883L194.266 65.354V68.75L191.105 70.1258"
      fill="white"
    />
    <path
      d="M190.809 66.2248L193.647 64.9883L194.266 65.354V68.75L191.105 70.1258"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M182.188 69.0363V73.094L184.705 74.1825L191.096 70.4904V66.4414"
      fill="white"
    />
    <path
      d="M182.188 69.0363V73.094L184.705 74.1825L191.096 70.4904V66.4414"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M184.705 74.1838V70.1348"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.274 65.3457L191.104 66.7215"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M190.809 62.1662L193.647 60.9297L194.266 61.2867V64.6914L191.105 66.0672"
      fill="white"
    />
    <path
      d="M190.809 62.1662L193.647 60.9297L194.266 61.2867V64.6914L191.105 66.0672"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M182.188 64.9786V69.0363L184.705 70.1248L191.096 66.4327V62.375"
      fill="white"
    />
    <path
      d="M182.188 64.9786V69.0363L184.705 70.1248L191.096 66.4327V62.375"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M184.705 70.1272V66.0781"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.274 61.2871L191.104 62.6629"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M188.598 61.2871L191.105 62.3669"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M190.809 58.1095L193.647 56.873L194.266 57.2301V60.6347L191.105 62.0105"
      fill="white"
    />
    <path
      d="M190.809 58.1095L193.647 56.873L194.266 57.2301V60.6347L191.105 62.0105"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M182.188 60.9219V64.971L184.705 66.0681L191.096 62.3761V58.3184"
      fill="white"
    />
    <path
      d="M182.188 60.9219V64.971L184.705 66.0681L191.096 62.3761V58.3184"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M184.705 66.0686V62.0195"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.274 57.2305L191.104 58.6063"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M191.114 53.9136L193.648 52.8164L194.266 53.1734V56.5781L191.114 57.9539"
      fill="white"
    />
    <path
      d="M191.114 53.9136L193.648 52.8164L194.266 53.1734V56.5781L191.114 57.9539"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M182.188 56.8633V60.9124L184.705 62.0008L191.096 58.3088V54.2598"
      fill="white"
    />
    <path
      d="M182.188 56.8633V60.9124L184.705 62.0008L191.096 58.3088V54.2598"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M184.705 62.01V57.9609"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.274 53.1719L191.104 54.539"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M191.079 49.8724L193.648 48.7578L194.266 49.1148V52.5195L191.21 53.8518"
      fill="white"
    />
    <path
      d="M191.079 49.8724L193.648 48.7578L194.266 49.1148V52.5195L191.21 53.8518"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M182.188 52.8067V56.8557L184.705 57.9442L191.096 54.2522V50.2031"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M184.705 57.9523V53.8945"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M194.274 49.1152L191.104 50.4823"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M148.873 67.3223H156.449"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M305.121 11.611L299.235 7.85803C296.196 5.9859 291.633 6.29937 286.556 9.23383L244.42 33.5629C235.321 38.8223 227.867 43.1499 227.867 59.6683V115.083C227.867 119.063 229.295 121.91 231.655 123.408L237.533 127.152C240.572 129.077 245.169 128.781 250.289 125.829L292.425 101.5C301.525 96.2402 308.97 91.8777 308.97 75.3942V19.979C308.97 15.9561 307.516 13.1 305.112 11.611H305.121Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M305.13 11.6032L299.243 7.85022C296.196 5.97808 291.633 6.29156 286.556 9.22602L244.412 33.5551C235.303 38.8145 227.858 43.1421 227.858 59.6692V115.093C227.858 119.072 229.286 121.92 231.646 123.418L237.524 127.171C240.563 129.095 245.16 128.799 250.28 125.838L292.425 101.5C301.533 96.2411 308.978 91.8786 308.978 75.3864V19.9538C308.978 15.9309 307.524 13.0748 305.121 11.5858"
      fill="white"
    />
    <path
      d="M237.532 127.161C235.163 125.663 233.744 122.825 233.744 118.837V63.4126C233.744 46.8856 241.189 42.5579 250.297 37.3072L292.442 12.9781C297.527 10.0437 302.09 9.73022 305.138 11.6111"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M295.996 93.35L252.667 118.367C248.365 120.849 244.839 119.36 244.839 115.058V61.3147C244.839 57.0132 248.357 51.4577 252.667 48.976L274.314 36.4806L296.005 23.9591C300.306 21.4774 303.824 22.9664 303.824 27.268V81.0113C303.824 85.3129 300.306 90.8683 296.005 93.35H295.996Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M244.743 34.4682L244.09 34.0851L286.931 9.35547L287.584 9.73861L244.743 34.4682Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M305.13 11.6032L299.243 7.85022C296.204 5.97808 291.642 6.29156 286.556 9.22602L244.412 33.5551C235.312 38.8145 227.858 43.1421 227.858 59.6605V115.084C227.858 119.072 229.286 121.911 231.646 123.409L237.524 127.162C240.563 129.086 245.16 128.79 250.28 125.838L292.425 101.509C301.525 96.2498 308.978 91.8873 308.978 75.4038V19.9799C308.978 15.957 307.524 13.1009 305.121 11.6119L305.13 11.6032Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M195.991 117.386V150.605L194.041 153.697L192.09 150.605V117.386M189.017 117.769C189.017 117.046 189.487 116.332 190.462 115.792C191.437 115.252 192.709 114.991 193.989 115.009C195.269 115.026 196.557 115.313 197.541 115.871C198.525 116.428 199.022 117.159 199.03 117.882V119.528C199.03 120.251 198.56 120.965 197.585 121.504C196.61 122.044 195.338 122.306 194.049 122.288C192.769 122.271 191.481 121.983 190.497 121.426C189.513 120.86 189.017 120.137 189.008 119.415V117.769H189.017Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M195.993 117.379V150.616L194.042 153.707L192.083 150.616V117.379"
      fill="white"
    />
    <path
      d="M192.065 121.018C192.466 121.741 193.659 121.889 194.721 121.349C195.54 120.931 196.045 120.234 196.054 119.607"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M192.571 117.797C192.623 117.962 192.762 118.128 192.98 118.25C193.572 118.598 194.538 118.589 195.148 118.241C195.374 118.11 195.514 117.953 195.575 117.779M192.17 150.311C192.553 150.999 193.668 151.138 194.678 150.624C195.444 150.233 195.923 149.571 195.932 148.979M192.161 148.482C192.544 149.17 193.668 149.31 194.678 148.796C195.444 148.404 195.923 147.742 195.94 147.141M192.153 146.654C192.536 147.342 193.668 147.49 194.678 146.967C195.453 146.575 195.932 145.905 195.94 145.313M192.153 144.825C192.536 145.522 193.668 145.661 194.686 145.139C195.461 144.738 195.94 144.076 195.958 143.475M192.144 142.988C192.527 143.684 193.668 143.824 194.686 143.301C195.461 142.901 195.949 142.23 195.958 141.629M192.135 141.159C192.518 141.856 193.668 142.004 194.686 141.481C195.47 141.081 195.958 140.41 195.966 139.801M192.126 139.331C192.518 140.036 193.659 140.175 194.686 139.653C195.47 139.252 195.958 138.573 195.975 137.964M192.126 137.502C192.518 138.207 193.668 138.347 194.695 137.824C195.479 137.424 195.975 136.744 195.984 136.135M192.118 135.665C192.51 136.37 193.668 136.518 194.695 135.987C195.488 135.586 195.975 134.898 195.993 134.289M192.109 133.836C192.501 134.541 193.659 134.689 194.695 134.158C195.488 133.749 195.984 133.07 195.993 132.452M192.109 132.008C192.501 132.722 193.668 132.861 194.713 132.33C195.514 131.92 196.001 131.233 196.019 130.614M192.1 130.179C192.492 130.893 193.668 131.041 194.713 130.501C195.514 130.092 196.01 129.404 196.019 128.786M192.092 128.35C192.492 129.064 193.659 129.212 194.713 128.673C195.514 128.263 196.01 127.567 196.027 126.948M192.083 126.513C192.483 127.227 193.659 127.375 194.713 126.844C195.522 126.426 196.019 125.738 196.027 125.111M192.083 124.684C192.483 125.407 193.668 125.555 194.721 125.015C195.531 124.597 196.036 123.901 196.045 123.274M192.074 122.856C192.475 123.579 193.659 123.727 194.721 123.187C195.531 122.769 196.036 122.072 196.045 121.437"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M195.983 117.378V148.377V150.597L194.041 153.689L192.1 150.597V117.369"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M189.008 117.761C189.008 117.038 189.478 116.324 190.453 115.784C191.429 115.245 192.709 114.983 193.989 115.001C195.269 115.018 196.557 115.306 197.55 115.863C198.534 116.429 199.03 117.152 199.039 117.874V119.52C199.039 120.243 198.569 120.957 197.593 121.497C196.618 122.037 195.338 122.298 194.058 122.28C192.778 122.263 191.49 121.976 190.506 121.41C189.522 120.844 189.017 120.121 189.017 119.398V117.752L189.008 117.761Z"
      fill="white"
    />
    <path
      d="M191.708 119.224C192.518 118.545 193.284 118.023 193.98 117.613C194.964 118.188 195.792 118.798 196.375 119.285C196.419 119.268 196.462 119.242 196.497 119.224C196.715 119.102 196.897 118.963 197.046 118.824C196.506 118.371 195.731 117.77 194.79 117.187C195.469 116.847 196.053 116.638 196.506 116.499C196.497 116.499 196.48 116.481 196.471 116.481C196.149 116.299 195.783 116.159 195.391 116.063C194.973 116.229 194.503 116.447 193.989 116.725C193.545 116.481 193.066 116.255 192.57 116.055C192.213 116.142 191.873 116.272 191.577 116.429C191.542 116.447 191.516 116.464 191.481 116.49C192.074 116.69 192.648 116.925 193.188 117.195C192.526 117.613 191.812 118.127 191.055 118.771C191.203 118.919 191.386 119.059 191.603 119.181C191.638 119.198 191.682 119.216 191.716 119.242"
      fill="#6B7073"
    />
    <path
      d="M199.04 117.883C199.04 118.605 198.57 119.319 197.595 119.851C196.619 120.391 195.339 120.652 194.059 120.634C192.779 120.617 191.491 120.33 190.507 119.772C189.523 119.215 189.026 118.492 189.018 117.77"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M190.445 115.792C189.47 116.332 189 117.046 189 117.769V119.415C189.009 120.137 189.505 120.86 190.489 121.426C191.473 121.983 192.762 122.271 194.042 122.288C195.322 122.306 196.602 122.044 197.577 121.504C198.552 120.965 199.022 120.251 199.022 119.528V117.882C199.014 117.159 198.517 116.437 197.533 115.871C196.549 115.313 195.261 115.026 193.981 115.009C192.701 114.991 191.421 115.252 190.445 115.792Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M171.991 132.862V166.082L170.041 169.173L168.09 166.082V132.862M165.017 133.245C165.017 132.523 165.487 131.809 166.462 131.269C167.437 130.729 168.709 130.468 169.989 130.485C171.269 130.503 172.557 130.79 173.541 131.347C174.525 131.905 175.022 132.636 175.03 133.359V135.004C175.03 135.727 174.56 136.441 173.585 136.981C172.61 137.521 171.338 137.782 170.049 137.765C168.769 137.747 167.481 137.46 166.497 136.903C165.513 136.337 165.017 135.614 165.008 134.891V133.245H165.017Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M171.993 132.855V166.092L170.042 169.184L168.083 166.092V132.855"
      fill="white"
    />
    <path
      d="M168.065 136.495C168.466 137.217 169.659 137.365 170.721 136.826C171.54 136.408 172.045 135.711 172.054 135.084"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M168.571 133.273C168.623 133.439 168.762 133.604 168.98 133.726C169.572 134.074 170.538 134.066 171.148 133.717C171.374 133.587 171.514 133.43 171.575 133.256M168.17 165.787C168.553 166.475 169.668 166.615 170.678 166.101C171.444 165.709 171.923 165.047 171.932 164.455M168.161 163.959C168.544 164.647 169.668 164.786 170.678 164.272C171.444 163.88 171.923 163.219 171.94 162.618M168.153 162.13C168.536 162.818 169.668 162.966 170.678 162.444C171.453 162.052 171.932 161.381 171.94 160.789M168.153 160.302C168.536 160.998 169.668 161.138 170.686 160.615C171.461 160.215 171.94 159.553 171.958 158.952M168.144 158.464C168.527 159.161 169.668 159.3 170.686 158.778C171.461 158.377 171.949 157.707 171.958 157.106M168.135 156.636C168.518 157.332 169.668 157.48 170.686 156.958C171.47 156.557 171.958 155.887 171.966 155.277M168.126 154.807C168.518 155.512 169.659 155.652 170.686 155.129C171.47 154.729 171.958 154.05 171.975 153.44M168.126 152.979C168.518 153.684 169.668 153.823 170.695 153.301C171.479 152.9 171.975 152.221 171.984 151.611M168.118 151.141C168.51 151.847 169.668 151.995 170.695 151.463C171.488 151.063 171.975 150.375 171.993 149.765M168.109 149.313C168.501 150.018 169.659 150.166 170.695 149.635C171.488 149.226 171.984 148.546 171.993 147.928M168.109 147.484C168.501 148.198 169.668 148.337 170.713 147.806C171.514 147.397 172.001 146.709 172.019 146.091M168.1 145.655C168.492 146.37 169.668 146.518 170.713 145.978C171.514 145.568 172.01 144.88 172.019 144.262M168.092 143.827C168.492 144.541 169.659 144.689 170.713 144.149C171.514 143.74 172.01 143.043 172.027 142.425M168.083 141.99C168.483 142.704 169.659 142.852 170.713 142.32C171.522 141.903 172.019 141.215 172.027 140.588M168.083 140.161C168.483 140.884 169.668 141.032 170.721 140.492C171.531 140.074 172.036 139.377 172.045 138.75M168.074 138.332C168.475 139.055 169.659 139.203 170.721 138.663C171.531 138.245 172.036 137.549 172.045 136.913"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M171.983 132.854V163.853V166.074L170.041 169.165L168.1 166.074V132.846"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M165.008 133.238C165.008 132.515 165.478 131.801 166.453 131.261C167.429 130.721 168.709 130.46 169.989 130.477C171.269 130.495 172.557 130.782 173.55 131.339C174.534 131.905 175.03 132.628 175.039 133.351V134.997C175.039 135.719 174.569 136.433 173.593 136.973C172.618 137.513 171.338 137.774 170.058 137.757C168.778 137.74 167.49 137.452 166.506 136.886C165.522 136.32 165.017 135.597 165.017 134.875V133.229L165.008 133.238Z"
      fill="white"
    />
    <path
      d="M167.708 134.701C168.518 134.022 169.284 133.499 169.98 133.09C170.964 133.665 171.792 134.274 172.375 134.762C172.419 134.744 172.462 134.718 172.497 134.701C172.715 134.579 172.897 134.44 173.046 134.3C172.506 133.847 171.731 133.247 170.79 132.663C171.469 132.324 172.053 132.115 172.506 131.975C172.497 131.975 172.48 131.958 172.471 131.958C172.149 131.775 171.783 131.636 171.391 131.54C170.973 131.705 170.503 131.923 169.989 132.202C169.545 131.958 169.066 131.732 168.57 131.531C168.213 131.618 167.873 131.749 167.577 131.906C167.542 131.923 167.516 131.941 167.481 131.967C168.074 132.167 168.648 132.402 169.188 132.672C168.526 133.09 167.812 133.604 167.055 134.248C167.203 134.396 167.386 134.535 167.603 134.657C167.638 134.675 167.682 134.692 167.716 134.718"
      fill="#6B7073"
    />
    <path
      d="M175.04 133.359C175.04 134.082 174.57 134.796 173.595 135.327C172.619 135.867 171.339 136.128 170.059 136.111C168.779 136.093 167.491 135.806 166.507 135.249C165.523 134.692 165.026 133.969 165.018 133.246"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M166.445 131.269C165.47 131.809 165 132.523 165 133.245V134.891C165.009 135.614 165.505 136.337 166.489 136.903C167.473 137.46 168.762 137.747 170.042 137.765C171.322 137.782 172.602 137.521 173.577 136.981C174.552 136.441 175.022 135.727 175.022 135.004V133.359C175.014 132.636 174.517 131.913 173.533 131.347C172.549 130.79 171.261 130.503 169.981 130.485C168.701 130.468 167.421 130.729 166.445 131.269Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M277.727 43.1674C277.675 43.0107 277.509 43.0107 277.353 43.1674L276.308 44.1688L276.586 43.2197C276.647 43.0107 276.586 42.8452 276.43 42.8539C276.282 42.8626 276.107 43.0455 276.038 43.2632L275.559 44.8828L274.418 45.98V44.5693L275.35 43.0716C275.472 42.8713 275.489 42.645 275.385 42.5666C275.28 42.4795 275.089 42.5753 274.967 42.7756L274.418 43.6463V42.3576C274.418 42.166 274.288 42.0877 274.122 42.1835C273.957 42.2792 273.826 42.5143 273.826 42.7059V43.9946L273.277 43.7508C273.156 43.6986 272.964 43.8205 272.859 44.0295C272.755 44.2384 272.764 44.4474 272.894 44.4997L273.826 44.9089V46.3196L272.685 46.546L272.206 45.4836C272.145 45.3443 271.971 45.3617 271.815 45.5185C271.667 45.6839 271.597 45.9277 271.658 46.067L271.936 46.694L270.892 46.8943C270.735 46.9291 270.569 47.1207 270.517 47.3296C270.465 47.5386 270.552 47.6867 270.709 47.6605L271.754 47.4603L271.135 48.2614C270.996 48.4442 270.953 48.6793 271.04 48.8012C271.092 48.8796 271.196 48.8796 271.292 48.8186C271.344 48.7838 271.397 48.7403 271.44 48.6793L272.503 47.3122L273.643 47.0858L272.938 48.6358L271.701 49.4717C271.536 49.5849 271.423 49.82 271.431 50.0029C271.449 50.177 271.571 50.238 271.728 50.1509C271.728 50.1509 271.745 50.1422 271.754 50.1335L272.476 49.6459L271.832 51.0565C271.736 51.2655 271.762 51.4658 271.902 51.5093C271.954 51.5267 272.015 51.5093 272.076 51.4745C272.172 51.4222 272.259 51.3177 272.311 51.1958L272.955 49.7852L273.121 50.5253C273.156 50.6647 273.277 50.7082 273.408 50.6298C273.434 50.6211 273.452 50.6037 273.478 50.5776C273.634 50.4383 273.739 50.1944 273.695 50.029L273.417 48.7751L274.122 47.2252L274.827 47.9653L274.549 49.5501C274.514 49.7591 274.61 49.8897 274.766 49.8374C274.784 49.8374 274.81 49.82 274.836 49.8026C274.967 49.7242 275.089 49.5501 275.123 49.3672L275.289 48.4442L275.933 49.1147C275.994 49.1757 276.081 49.1757 276.168 49.1147C276.229 49.0799 276.29 49.0276 276.343 48.9493C276.473 48.7577 276.508 48.5226 276.412 48.4268L275.768 47.7563L276.491 47.408C276.491 47.408 276.508 47.408 276.517 47.3993C276.665 47.3122 276.795 47.1032 276.813 46.9117C276.83 46.7114 276.708 46.6156 276.543 46.694L275.306 47.2861L274.601 46.546L275.742 45.4488L276.804 45.5881C276.856 45.5881 276.909 45.5881 276.961 45.5533C277.057 45.4923 277.161 45.3791 277.213 45.2398C277.3 45.0221 277.257 44.8393 277.109 44.8219L276.491 44.7348L277.535 43.7334C277.692 43.5854 277.779 43.3416 277.727 43.1848"
      fill="#6B7073"
    />
    <path
      d="M292.895 50.0642C292.895 49.176 292.277 48.819 291.545 49.237C290.805 49.6636 290.196 50.726 290.196 51.6228C290.196 52.5197 290.805 52.8854 291.545 52.4588C292.277 52.0408 292.895 50.9698 292.895 50.0642ZM289.412 52.0756C289.412 50.6998 290.37 49.0454 291.545 48.3575C292.721 47.6783 293.679 48.2356 293.679 49.6114C293.679 50.9872 292.721 52.659 291.545 53.3382C290.361 54.0174 289.412 53.4601 289.412 52.0843"
      fill="#6B7073"
    />
    <path
      d="M272.294 60.8351L260.896 94.3942L259.477 95.2127L270.823 61.9236L256.351 70.2742V68.9071L272.294 59.7031V60.8351Z"
      fill="#6B7073"
    />
    <path
      d="M275.106 77.4938C275.106 81.8476 278.041 83.3715 282.064 81.0465C286.087 78.7216 289.012 73.8279 289.012 69.4654C289.012 65.1029 286.095 63.5791 282.064 65.904C278.023 68.2377 275.106 73.14 275.106 77.4938ZM277.954 68.0809C279.181 66.6267 280.583 65.4164 282.064 64.563C286.809 61.8202 290.275 63.6575 290.275 68.734C290.275 73.8105 286.809 79.6446 282.064 82.3875C277.301 85.1391 273.844 83.3018 273.844 78.2253C273.844 76.4228 274.288 74.542 275.124 72.426L282.525 53.8004L284.032 52.9297L277.954 68.0809Z"
      fill="#6B7073"
    />
    <path
      d="M85.8673 135.438C86.59 136.614 87.4259 137.981 87.722 141.838C87.722 142.03 87.7916 142.23 87.9223 142.404L88.3838 143.179C87.9484 143.467 87.722 144.738 87.722 145.095V145.774C87.722 145.966 87.7916 146.157 87.9135 146.34L88.4186 148.099C87.9571 148.387 87.722 148.752 87.722 149.118V149.797C87.722 149.989 87.7916 150.18 87.9135 150.363L88.4186 152.122C87.9571 152.41 87.722 152.775 87.722 153.141V153.82C87.722 154.012 87.7916 154.212 87.9223 154.386L88.8888 155.771C88.9672 155.875 89.0804 155.971 89.2284 156.058C89.5419 156.241 89.9598 156.328 90.3778 156.328C90.7958 156.328 91.205 156.241 91.5272 156.058C91.6752 155.971 91.7885 155.875 91.8668 155.771L92.8334 154.386C92.964 154.203 93.0336 154.012 93.0336 153.811V153.132C93.0336 152.767 92.7985 152.401 92.337 152.113L92.8421 150.355C92.9727 150.172 93.0336 149.98 93.0336 149.789V149.109C93.0336 148.744 92.7985 148.378 92.337 148.091L92.8421 146.332C92.9727 146.149 93.0336 145.957 93.0336 145.766V145.086C93.0336 144.729 92.8159 143.458 92.3718 143.171L92.8421 142.387C92.9727 142.204 93.0336 142.013 93.0336 141.821C93.3384 137.964 94.1656 136.597 94.8883 135.421C95.2192 134.864 94.1046 134.01 93.5212 135.195C92.9465 136.257 92.276 137.668 92.0409 140.646C92.0235 140.646 92.0061 140.628 91.9887 140.619V139.635C91.9887 137.52 93.0249 135.168 93.0249 135.168V124.65L94.035 118.319V117.954H92.9988C92.9291 117.631 92.6766 117.327 92.25 117.083C91.7362 116.787 91.057 116.639 90.3778 116.639C89.6986 116.639 89.0194 116.787 88.5056 117.083C88.079 117.327 87.8265 117.64 87.7568 117.954H86.7206V118.319L87.7307 124.65V135.168C87.7307 135.168 88.7669 137.52 88.7669 139.635L88.7147 140.637C88.4796 137.668 87.8091 136.257 87.2344 135.195C86.651 134.002 85.5451 134.855 85.8673 135.421V135.438Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M90.0208 153.898H89.9946C89.9946 153.898 90.0121 153.898 90.0208 153.898V135.638C90.0208 135.447 90.1775 135.281 90.3691 135.281C90.5606 135.281 90.7174 135.438 90.7174 135.638V153.898C90.7174 153.898 90.7261 153.898 90.7348 153.898H90.7174V155.396C90.7174 155.588 90.5606 155.744 90.3691 155.744C90.1775 155.744 90.0208 155.588 90.0208 155.396V153.907V153.898ZM85.8498 135.438C86.5812 136.614 87.4085 137.981 87.7132 141.838C87.7132 142.03 87.7829 142.23 87.9135 142.404L88.375 143.179C87.9309 143.467 87.7132 144.738 87.7132 145.095V145.774C87.7132 145.966 87.7742 146.157 87.9048 146.34L88.4098 148.108C87.9396 148.395 87.7045 148.761 87.7045 149.127V149.814C87.7045 150.006 87.7655 150.198 87.8961 150.38L88.4011 152.148C87.9309 152.435 87.6958 152.801 87.6958 153.176V153.855C87.6958 154.046 87.7568 154.247 87.8961 154.43L88.8627 155.814C88.941 155.919 89.0542 156.014 89.2023 156.101C89.5157 156.284 89.9337 156.371 90.3517 156.371C90.7696 156.371 91.1876 156.284 91.501 156.101C91.6491 156.014 91.7623 155.919 91.8406 155.814L92.8072 154.43C92.9378 154.247 93.0075 154.055 93.0075 153.855V153.176C93.0075 152.81 92.7724 152.444 92.3022 152.148L92.8072 150.38C92.9378 150.198 92.9988 150.006 92.9988 149.814V149.127C92.9988 148.761 92.7637 148.395 92.2935 148.108L92.7985 146.34C92.9291 146.157 92.9901 145.966 92.9901 145.774V145.095C92.9901 144.738 92.7636 143.467 92.3283 143.179L92.7985 142.396C92.9291 142.213 92.9901 142.021 92.9901 141.83C93.2948 137.972 94.1221 136.605 94.8535 135.43C95.1844 134.872 94.0698 134.019 93.4864 135.203C92.9117 136.265 92.2325 137.676 91.9974 140.654C91.98 140.654 91.9625 140.637 91.9451 140.628V139.644C91.9451 137.528 92.9901 135.177 92.9901 135.177V124.65L94.0001 118.31V117.936H92.964C92.8943 117.614 92.6417 117.309 92.2063 117.065C91.6839 116.769 91.0047 116.621 90.3255 116.621C89.6463 116.621 88.9672 116.769 88.4447 117.065C88.0093 117.309 87.7655 117.622 87.6958 117.936H86.6596V118.31L87.6697 124.65V135.177C87.6697 135.177 88.7146 137.537 88.7146 139.644L88.6624 140.645C88.4273 137.667 87.7481 136.265 87.1734 135.194C86.59 134.001 85.4754 134.855 85.8063 135.421"
      fill="white"
    />
    <path
      d="M90.7259 155.387C90.7259 155.579 90.5692 155.736 90.3776 155.736C90.1861 155.736 90.0293 155.579 90.0293 155.387V153.898H90.7346V155.387H90.7259Z"
      fill="white"
    />
    <path
      d="M93.0068 118.328V124.702"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M93.0068 131.34H94.043"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M93.0237 153.176C93.0237 153.559 92.7625 153.942 92.2487 154.238C92.1617 154.29 92.0745 154.334 91.9875 154.369M88.7047 154.343C88.6351 154.308 88.5654 154.273 88.5044 154.238C87.9907 153.942 87.7295 153.559 87.7295 153.176"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M89.9941 153.899C90.116 153.882 90.2467 153.873 90.3686 153.873C90.4905 153.873 90.6211 153.873 90.743 153.899"
      fill="#6B7073"
    />
    <path
      d="M89.0878 118.878C88.7308 118.677 88.5566 118.407 88.5566 118.146C88.5566 117.885 88.7308 117.615 89.0878 117.415C89.4448 117.214 89.9063 117.11 90.3765 117.11C90.8467 117.11 91.3082 117.214 91.6652 117.415C92.0222 117.615 92.1964 117.885 92.1964 118.146C92.1964 118.407 92.0222 118.677 91.6652 118.878C91.3082 119.078 90.8467 119.182 90.3765 119.182C89.9063 119.182 89.4448 119.087 89.0878 118.878ZM88.4957 119.217C87.9819 118.921 87.7207 118.538 87.7207 118.155C87.7207 117.772 87.9819 117.389 88.4957 117.093C89.0094 116.796 89.6886 116.648 90.3678 116.648C91.047 116.648 91.7262 116.796 92.24 117.093C92.7624 117.389 93.0149 117.772 93.0149 118.155C93.0149 118.538 92.7537 118.93 92.24 119.217C91.7262 119.505 91.047 119.661 90.3678 119.661C89.6886 119.661 89.0094 119.513 88.4957 119.217Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M92.8321 150.389C92.7014 150.572 92.5099 150.746 92.2487 150.894C92.1529 150.947 92.0484 150.999 91.9352 151.042M88.7134 150.999C88.6437 150.964 88.5653 150.929 88.5044 150.894C88.2431 150.746 88.0516 150.572 87.921 150.389M92.8321 154.43C92.7014 154.613 92.5099 154.778 92.2573 154.926C92.1615 154.978 92.0571 155.031 91.9439 155.083M88.8004 155.074C88.6959 155.031 88.5915 154.978 88.4957 154.926C88.2345 154.778 88.0429 154.613 87.9122 154.43M92.0135 140.654C92.1006 140.689 92.179 140.733 92.2573 140.776C92.7711 141.072 93.0323 141.455 93.0323 141.847M93.0236 141.847C93.0236 142.23 92.7624 142.622 92.2487 142.918C92.1529 142.971 92.0571 143.014 91.9613 143.058M88.7482 143.04C88.6611 143.005 88.5741 142.962 88.4957 142.91C87.9732 142.614 87.7207 142.23 87.7207 141.839M87.7207 141.847C87.7207 141.464 87.9819 141.072 88.4957 140.776C88.5479 140.75 88.6002 140.715 88.6524 140.689"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M92.833 150.399L91.997 152.707M88.7578 152.707L87.9219 150.391"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M93.0236 149.145C93.0236 149.528 92.7624 149.911 92.2487 150.207C92.1703 150.25 92.0832 150.294 91.9961 150.337M88.722 150.32C88.6437 150.285 88.5654 150.25 88.4957 150.207C87.9819 149.911 87.7207 149.528 87.7207 149.145"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M92.8329 146.359C92.7023 146.542 92.5107 146.708 92.2495 146.856C92.1537 146.908 92.0579 146.96 91.9534 147.004M88.7838 146.995C88.6881 146.952 88.5923 146.908 88.4965 146.856C88.2353 146.708 88.0437 146.542 87.9131 146.359"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M92.833 146.359L91.997 148.667M88.7665 148.693L87.9219 146.368"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M93.0236 145.105C93.0236 145.489 92.7624 145.872 92.2487 146.168C92.1703 146.211 92.0919 146.255 92.0135 146.29M88.7482 146.298C88.6611 146.264 88.5828 146.22 88.4957 146.177C87.9819 145.88 87.7207 145.497 87.7207 145.114"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M87.7207 118.285V124.659M92.8321 142.405L91.9874 144.73M88.7569 144.739L87.9122 142.414"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M87.7384 131.34H86.7021"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M90.3776 155.745C90.5692 155.745 90.7259 155.588 90.7259 155.397V135.639C90.7259 135.448 90.5692 135.291 90.3776 135.291C90.1861 135.291 90.0293 135.448 90.0293 135.639V155.397C90.0293 155.588 90.1861 155.745 90.3776 155.745Z"
      fill="#6B7073"
    />
    <path
      d="M93.0236 124.676C93.0236 125.059 92.7624 134.62 92.2487 134.907C92.1703 134.951 92.0832 134.994 91.9961 135.038V155.448M87.7207 124.676C87.7207 125.059 87.9819 134.62 88.4957 134.907C88.5741 134.951 88.6611 134.994 88.7482 135.038V155.448"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M87.2251 135.222C87.7998 136.284 88.4703 137.695 88.7142 140.664L88.7664 139.663C88.7664 137.547 87.7215 135.196 87.7215 135.196V124.668L86.7114 118.329V117.963H87.7476C87.8172 117.641 88.0698 117.336 88.4965 117.093C89.0189 116.796 89.6981 116.648 90.3686 116.648C91.0391 116.648 91.727 116.796 92.2407 117.093C92.6761 117.336 92.9199 117.65 92.9896 117.963H94.0258V118.329L93.0157 124.668V135.196C93.0157 135.196 91.9708 137.555 91.9708 139.663V140.647C91.9708 140.647 92.0056 140.664 92.023 140.673C92.2581 137.695 92.9373 136.284 93.512 135.222C94.0954 134.029 95.2013 134.882 94.8791 135.448C94.1564 136.624 93.3205 137.991 93.0157 141.848C93.0157 142.04 92.9547 142.231 92.8241 142.414L92.3539 143.198C92.7893 143.485 93.0157 144.757 93.0157 145.114V145.793C93.0157 145.984 92.9547 146.176 92.8241 146.359L92.3191 148.118C92.7806 148.405 93.0157 148.771 93.0157 149.137V149.816C93.0157 150.007 92.9547 150.199 92.8241 150.382L92.3191 152.141C92.7806 152.428 93.0157 152.794 93.0157 153.159V153.839C93.0157 154.03 92.946 154.23 92.8154 154.413L91.8489 155.798C91.7705 155.902 91.6573 155.998 91.5093 156.085C91.1958 156.268 90.7778 156.355 90.3599 156.355C89.9419 156.355 89.5239 156.268 89.2104 156.085C89.0624 155.998 88.9493 155.902 88.8709 155.798L87.9043 154.413C87.7737 154.23 87.7128 154.039 87.7128 153.839V153.159C87.7128 152.794 87.9479 152.428 88.4094 152.132L87.9043 150.373C87.7737 150.19 87.7128 149.999 87.7128 149.807V149.128C87.7128 148.762 87.9479 148.396 88.4094 148.109L87.9043 146.35C87.7737 146.167 87.7128 145.976 87.7128 145.784V145.105C87.7128 144.748 87.9305 143.477 88.3745 143.189L87.913 142.414C87.7824 142.231 87.7215 142.04 87.7215 141.84C87.4167 137.982 86.5895 136.615 85.858 135.439C85.5272 134.882 86.6417 134.029 87.2251 135.213V135.222Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M62.5225 148.474C63.2453 149.649 64.0812 151.016 64.3773 154.874C64.3773 155.065 64.4469 155.257 64.5775 155.44L65.0391 156.215C64.6037 156.502 64.3773 157.773 64.3773 158.13V158.809C64.3773 159.001 64.4469 159.193 64.5688 159.375L65.0739 161.134C64.6124 161.422 64.3773 161.787 64.3773 162.153V162.832C64.3773 163.024 64.4469 163.216 64.5688 163.398L65.0739 165.157C64.6124 165.445 64.3773 165.81 64.3773 166.176V166.855C64.3773 167.047 64.4469 167.247 64.5775 167.43L65.5441 168.815C65.6224 168.919 65.7356 169.015 65.8837 169.102C66.1971 169.285 66.6151 169.372 67.0331 169.372C67.451 169.372 67.8603 169.285 68.1825 169.102C68.3305 169.015 68.4437 168.919 68.5221 168.815L69.4886 167.43C69.6192 167.247 69.6889 167.056 69.6889 166.855V166.176C69.6889 165.81 69.4538 165.445 68.9923 165.157L69.4973 163.398C69.628 163.216 69.6889 163.024 69.6889 162.832V162.153C69.6889 161.787 69.4538 161.422 68.9923 161.134L69.4973 159.375C69.628 159.193 69.6889 159.001 69.6889 158.809V158.13C69.6889 157.773 69.4712 156.502 69.0271 156.215L69.4973 155.431C69.628 155.248 69.6889 155.057 69.6889 154.865C69.9937 151.007 70.8209 149.64 71.5436 148.465C71.8745 147.908 70.7599 147.054 70.1765 148.238C69.6018 149.301 68.9313 150.711 68.6962 153.689C68.6788 153.689 68.6614 153.672 68.644 153.663V152.679C68.644 150.563 69.6802 148.212 69.6802 148.212V137.694L70.6903 131.363V130.989H69.6541C69.5844 130.667 69.3319 130.362 68.9052 130.118C68.3915 129.822 67.7123 129.674 67.0331 129.674C66.3539 129.674 65.6747 129.822 65.1609 130.118C64.7342 130.362 64.4817 130.675 64.4121 130.989H63.3759V131.363L64.386 137.694V148.212C64.386 148.212 65.4222 150.563 65.4222 152.679L65.3699 153.681C65.1348 150.711 64.4556 149.301 63.8896 148.238C63.3062 147.046 62.2004 147.899 62.5225 148.465V148.474Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M66.6742 166.934H66.648C66.648 166.934 66.6655 166.934 66.6742 166.934V148.674C66.6742 148.482 66.8309 148.317 67.0225 148.317C67.214 148.317 67.3708 148.473 67.3708 148.674V166.934C67.3708 166.934 67.3794 166.934 67.3882 166.934H67.3708V168.431C67.3708 168.623 67.214 168.78 67.0225 168.78C66.8309 168.78 66.6742 168.623 66.6742 168.431V166.942V166.934ZM62.5032 148.473C63.2346 149.649 64.0619 151.016 64.3666 154.873C64.3666 155.065 64.4276 155.265 64.5669 155.439L65.0284 156.214C64.5843 156.502 64.3666 157.773 64.3666 158.13V158.809C64.3666 159.001 64.4276 159.192 64.5582 159.375L65.0632 161.143C64.593 161.43 64.3579 161.796 64.3579 162.162V162.85C64.3579 163.041 64.4189 163.233 64.5495 163.416L65.0545 165.175C64.5843 165.462 64.3492 165.828 64.3492 166.202V166.881C64.3492 167.073 64.4102 167.273 64.5495 167.456L65.5161 168.84C65.5944 168.945 65.7076 169.041 65.8557 169.128C66.1691 169.311 66.5871 169.398 67.005 169.398C67.423 169.398 67.841 169.311 68.1544 169.128C68.3025 169.041 68.4157 168.945 68.494 168.84L69.4606 167.456C69.5912 167.273 69.6609 167.082 69.6609 166.881V166.202C69.6609 165.836 69.4258 165.471 68.9556 165.183L69.4606 163.416C69.5912 163.233 69.6522 163.041 69.6522 162.85V162.162C69.6522 161.796 69.4171 161.43 68.9469 161.143L69.4519 159.375C69.5825 159.192 69.6434 159.001 69.6434 158.809V158.13C69.6434 157.773 69.417 156.502 68.9817 156.214L69.4519 155.431C69.5825 155.248 69.6434 155.056 69.6434 154.865C69.9482 151.007 70.7754 149.64 71.5069 148.465C71.8378 147.899 70.7232 147.054 70.1398 148.238C69.5651 149.301 68.8859 150.711 68.6508 153.689C68.6334 153.689 68.6159 153.672 68.5985 153.663V152.679C68.5985 150.563 69.6434 148.212 69.6434 148.212V137.685L70.6535 131.346V130.971H69.6173C69.5476 130.649 69.2951 130.344 68.8685 130.1C68.346 129.804 67.6668 129.656 66.9876 129.656C66.3084 129.656 65.6292 129.804 65.1068 130.1C64.6714 130.344 64.4276 130.658 64.3579 130.971H63.3217V131.346L64.3318 137.685V148.212C64.3318 148.212 65.3767 150.572 65.3767 152.679L65.3245 153.681C65.0894 150.703 64.4102 149.301 63.8355 148.23C63.2521 147.037 62.1375 147.89 62.4684 148.456"
      fill="white"
    />
    <path
      d="M87.3802 168.425C87.3802 168.616 87.2235 168.773 87.0319 168.773C86.8404 168.773 86.6836 168.616 86.6836 168.425V166.936H87.3889V168.425H87.3802Z"
      fill="white"
    />
    <path
      d="M69.6709 131.363V137.737"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M69.6611 131.363H70.6973"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M89.6789 166.211C89.6789 166.594 89.4177 166.977 88.9039 167.273C88.8169 167.326 88.7298 167.369 88.634 167.404M85.3512 167.378C85.2816 167.343 85.2119 167.308 85.151 167.273C84.6372 166.977 84.376 166.594 84.376 166.211"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M86.6484 166.934C86.7703 166.917 86.901 166.908 87.0229 166.908C87.1448 166.908 87.2754 166.908 87.3973 166.934"
      fill="#6B7073"
    />
    <path
      d="M65.7431 131.913C65.3861 131.712 65.2119 131.451 65.2119 131.181C65.2119 130.92 65.3861 130.65 65.7431 130.45C66.1001 130.25 66.5616 130.145 67.0318 130.145C67.502 130.145 67.9635 130.25 68.3205 130.45C68.6775 130.65 68.8517 130.92 68.8517 131.181C68.8517 131.443 68.6775 131.712 68.3205 131.913C67.9635 132.113 67.502 132.218 67.0318 132.218C66.5616 132.218 66.1001 132.113 65.7431 131.913ZM65.151 132.252C64.6372 131.956 64.376 131.573 64.376 131.19C64.376 130.807 64.6372 130.415 65.151 130.128C65.6647 129.832 66.3439 129.684 67.0231 129.684C67.7023 129.684 68.3815 129.832 68.8952 130.128C69.4177 130.424 69.6702 130.807 69.6702 131.19C69.6702 131.573 69.409 131.956 68.8952 132.252C68.3815 132.548 67.7023 132.696 67.0231 132.696C66.3439 132.696 65.6647 132.548 65.151 132.252Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M69.4873 163.427C69.3567 163.609 69.1652 163.784 68.9039 163.932C68.8082 163.984 68.7036 164.036 68.5904 164.08M65.3599 164.036C65.2903 164.001 65.2119 163.966 65.151 163.932C64.8897 163.784 64.6981 163.609 64.5675 163.427M69.4786 167.467C69.348 167.65 69.1565 167.815 68.8952 167.963C68.7994 168.015 68.695 168.068 68.5818 168.12M65.4557 168.111C65.3512 168.068 65.2467 168.015 65.151 167.963C64.8897 167.815 64.6981 167.65 64.5675 167.467M68.6601 153.691C68.7472 153.726 68.8256 153.77 68.9039 153.813C69.4177 154.109 69.6789 154.501 69.6789 154.884C69.6789 155.267 69.4177 155.659 68.9039 155.955C68.8082 156.008 68.7124 156.051 68.6166 156.095M65.4035 156.077C65.3164 156.042 65.2293 155.999 65.151 155.947C64.6285 155.651 64.376 155.267 64.376 154.876M64.376 154.884C64.376 154.501 64.6372 154.109 65.151 153.813C65.2032 153.787 65.2555 153.761 65.3077 153.726"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M69.4786 163.434L68.6426 165.742M65.4121 165.742L64.5762 163.426"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M69.6789 162.18C69.6789 162.563 69.4177 162.946 68.9039 163.242C68.8256 163.286 68.7385 163.329 68.6514 163.373M65.3773 163.355C65.299 163.32 65.2206 163.286 65.151 163.242C64.6372 162.946 64.376 162.563 64.376 162.18"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M69.4882 159.395C69.3576 159.577 69.166 159.743 68.9048 159.891C68.809 159.943 68.7132 159.995 68.6087 160.039M65.4391 160.03C65.3433 159.987 65.2476 159.943 65.1518 159.891C64.8906 159.743 64.699 159.577 64.5684 159.395"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M69.4786 159.395L68.6426 161.702M65.4208 161.719L64.5762 159.395"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M69.6789 158.141C69.6789 158.524 69.4177 158.907 68.9039 159.203C68.8256 159.246 68.7472 159.29 68.6688 159.325M65.4035 159.325C65.3164 159.29 65.238 159.246 65.151 159.203C64.6372 158.907 64.376 158.524 64.376 158.141"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M64.376 131.32V137.703M69.4786 155.44L68.634 157.765M65.4122 157.774L64.5675 155.449"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M64.3936 131.363H63.3574"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M67.0231 168.78C67.2146 168.78 67.3714 168.624 67.3714 168.432V148.674C67.3714 148.483 67.2146 148.326 67.0231 148.326C66.8315 148.326 66.6748 148.483 66.6748 148.674V168.432C66.6748 168.624 66.8315 168.78 67.0231 168.78Z"
      fill="#6B7073"
    />
    <path
      d="M69.6789 137.703C69.6789 138.086 69.4177 147.647 68.9039 147.935C68.8256 147.978 68.7385 148.022 68.6514 148.065V168.476M64.376 137.703C64.376 138.086 64.6372 147.647 65.151 147.935C65.2293 147.978 65.3164 148.022 65.4035 148.065V168.476"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M63.8795 148.248C64.4542 149.311 65.1247 150.721 65.3685 153.69L65.4208 152.689C65.4208 150.573 64.3758 148.222 64.3758 148.222V137.695L63.3657 131.364V130.998H64.4019C64.4716 130.676 64.7242 130.372 65.1508 130.128C65.6733 129.832 66.3525 129.684 67.0229 129.684C67.6934 129.684 68.3813 129.832 68.8951 130.128C69.3305 130.372 69.5743 130.685 69.6439 130.998H70.6801V131.364L69.6701 137.695V148.222C69.6701 148.222 68.6252 150.582 68.6252 152.689V153.673C68.6252 153.673 68.66 153.69 68.6774 153.699C68.9125 150.721 69.5917 149.311 70.1664 148.248C70.7498 147.055 71.8557 147.909 71.5335 148.475C70.8107 149.65 69.9748 151.017 69.6787 154.875C69.6787 155.066 69.6091 155.258 69.4872 155.441L69.017 156.224C69.4524 156.512 69.6787 157.783 69.6787 158.14V158.819C69.6787 159.011 69.6091 159.202 69.4872 159.385L68.9822 161.144C69.4437 161.432 69.6787 161.797 69.6787 162.163V162.842C69.6787 163.034 69.6091 163.225 69.4872 163.408L68.9822 165.167C69.4437 165.454 69.6787 165.82 69.6787 166.195V166.874C69.6787 167.065 69.6091 167.266 69.4785 167.448L68.512 168.833C68.4336 168.937 68.3204 169.033 68.1724 169.12C67.8589 169.303 67.4409 169.39 67.0229 169.39C66.605 169.39 66.187 169.303 65.8735 169.12C65.7255 169.033 65.6123 168.937 65.534 168.833L64.5674 167.448C64.4368 167.266 64.3758 167.074 64.3758 166.874V166.195C64.3758 165.829 64.6109 165.463 65.0724 165.167L64.5674 163.408C64.4368 163.225 64.3758 163.034 64.3758 162.842V162.163C64.3758 161.797 64.6109 161.432 65.0724 161.144L64.5674 159.385C64.4368 159.202 64.3758 159.011 64.3758 158.819V158.14C64.3758 157.783 64.5935 156.512 65.0376 156.224L64.5761 155.449C64.4455 155.267 64.3846 155.075 64.3846 154.875C64.0798 151.017 63.2526 149.65 62.5211 148.475C62.1902 147.917 63.3048 147.064 63.8882 148.248H63.8795Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <rect
      x={55.5947}
      y={7.67773}
      width={17.2584}
      height={17.2584}
      rx={8.62918}
      fill="#01B5DE"
    />
    <path
      d="M64.1931 13.6466C64.0331 13.7866 63.8531 13.8833 63.6531 13.9366C63.4597 13.9833 63.1931 14.0066 62.8531 14.0066V13.2066H63.0131C63.3731 13.2066 63.6497 13.1366 63.8431 12.9966C64.0364 12.85 64.1531 12.62 64.1931 12.3066H65.1531V19.3066H64.1931V13.6466Z"
      fill="white"
    />
    <path
      d="M200 77.0667C200 77.0667 194.491 70.1557 191.895 65.3896C189.856 61.6461 192.475 57.1347 187.605 55.537C185.038 54.695 183.142 54.959 180.453 55.537C171.993 57.3558 175.712 71.7784 176.127 73.2897C176.152 73.3807 176.163 73.4656 176.163 73.56V77.0667M174.256 82.9053C174.433 75.3139 174.704 63.6737 174.73 62.5571C174.732 62.4938 174.739 62.4402 174.754 62.3787C174.889 61.8394 175.668 59.092 177.593 58.8212C179.574 58.5426 181.884 59.1861 181.884 61.3756C181.884 68.8419 185.623 76.9937 187.605 79.6211M183.791 80.7158C183.791 80.7158 181.417 78.4073 180.453 76.7018C178.813 73.7974 179.023 71.8379 179.023 68.6738C179.023 66.8492 178.796 64.3712 176.163 63.5651C174.78 63.1416 173.804 63.3213 172.349 63.5651C165.791 64.6635 171.456 71.5639 171.395 76.7018C171.383 77.6993 171.395 79.2562 171.395 79.2562M173.779 78.1614C173.779 78.1614 172.458 72.5556 170.02 69.4721C169.983 69.426 169.95 69.3762 169.921 69.3249C168.087 66.0537 165.83 66.2406 164.824 66.7889C164.754 66.8271 164.69 66.8792 164.637 66.9382C162.565 69.2183 165.856 72.1122 166.628 74.8773C167.28 77.2134 169.011 80.7158 169.011 80.7158M168.058 84C168.058 84 166.367 75.8502 163.29 71.2282C158.046 63.565 151.609 62.6295 157.093 71.5931C159.708 75.8676 164.721 82.1755 164.721 82.1755"
      stroke="#6B7073"
      strokeWidth={0.5}
    />
  </svg>
)

export default IgTrimPlate
